import React from 'react'
import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom'

// Users with the admin flag see everything.
// Non-admin users who hold at least one admin-area permission
// (e.g. pipeline:view granted by a Super Admin) can enter /admin/*
// and will see only the sections their permissions allow.
const ADMIN_AREA_PERMISSIONS = [
  'customers:view', 'customers:admin', 'team:view', 'team:manage',
  'team:permissions', 'system:admin', 'system:audit',
  'system:integrations', 'system:settings',
  'pipeline:view', 'pipeline:edit', 'pipeline:admin', 'pipeline:hubspot',
]

const AdminRoute = ({ admin, permissions, children }) => {
  if (admin) return <>{children}</>
  const hasAccess = (permissions || []).some(p => ADMIN_AREA_PERMISSIONS.includes(p))
  if (hasAccess) return <>{children}</>
  return <Navigate to="/dashboard" replace />
}

const mapStateToProps = store => ({
  admin: !!store.root.admin,
  permissions: store.root.permissions || [],
})

export default connect(mapStateToProps)(AdminRoute)
